<div class="card-block" *ngIf="!!currentChart">
    <div [chart]="currentChart"></div>
</div>